import React, { useEffect, useState, useRef } from "react";
import { DataGrid, GridRowModes, GridToolbarContainer } from '@mui/x-data-grid';
import { Button, Grid, Snackbar, TextField } from '@material-ui/core';
import { Avatar } from '@material-ui/core';
import { post } from "../../api/api";
import { decrypt, getDateWithFormat } from "../../utils/utils";
import { saveInmateOffline, submitInmateOffline } from "../../offlineManager/inventoryOffline";
import { addInmateSubmitFormealPeriod, deleteDb, deleteDocFromCollection, getAllOfTable, getSingleInmate, getSingleMealPeriodId, getSingleRecordUsingKey, removeCollection, updateSingleMealPeriodId } from "../../offlineManager/localbase";
import { Alert } from "@material-ui/lab";
import './inmateScanGrid.scss'
import { format } from "date-fns";
import useOnlineStatus from "../../useOnlineStatus";
import ModalPopup from "f1-modal-react";
import Loader from "../../components/loader/loader";
import { useNavigate } from "react-router-dom";
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { ApiUrls } from "../../api/baseURL";
import { metaDataConstants } from "../../utils/Constants/constants-en";

const InmateScanGrid = () => {

    const dataGridRef = useRef()
    const isOnline = useOnlineStatus();
    const [rows, setRows] = useState([])
    const [activateLoader, setActivateLoader] = useState(false);
    const [selectionModel, setSelectionModel] = React.useState([]);
    const [show, setShow] = useState(false);
    const [serverityStatus, setServerityStatus] = useState("");
    const [message, setMessage] = useState("");
    const [showPostSubmitPopup, setShowPostSubmitPopup] = useState(false);
    const [showDeleteConfirmPopup, setShowDeleteConfirmPopup] = useState(false);
    let navigate = useNavigate();

    const [state, setState] = useState({
        activateLoader: false,
        show: false,
        serverityStatus: "",
        message: "",
    });

    useEffect(() => {
        getSavedInmateDetails();
    }, []);

    const getSavedInmateDetails = async () => {
        const inmatesRecord = await getAllOfTable("Inmates");
        if (inmatesRecord) {
            setRows(inmatesRecord)
        }
    }
    const handleClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setState({ ...state, show: false });
        setShow(false)
    };

    const getPatientName = (firstName, lastName) => {
        const patientFirstName = decrypt(firstName);
        const patientLastName = decrypt(lastName);
        return patientLastName + ', ' + patientFirstName;
    }
    const playBeep = (duration, isError = false) => {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) {
            alert(metaDataConstants.noBeepInBrowser);
            return;
        }
        const context = new AudioContext();
        const oscillator = context.createOscillator();
        const gainNode = context.createGain();

        if (isError) {
            oscillator.type = 'triangle'; // Softer and less harsh compared to sawtooth
            oscillator.frequency.setValueAtTime(500, context.currentTime); // Medium-low frequency for error sound
    
            //pulsing effect
            const pulseDuration = 0.2; // Longer pulse for a smoother transition
            for (let t = 0; t < duration; t += pulseDuration * 2) {
                gainNode.gain.setValueAtTime(0.7, context.currentTime + t); // Slightly lower volume
                gainNode.gain.setValueAtTime(0.3, context.currentTime + t + pulseDuration); // Reduced variation
            }
        } else {
            oscillator.type = 'sine';
            oscillator.frequency.setValueAtTime(1500, context.currentTime);
        }
        oscillator.connect(context.destination);
        oscillator.start();
        oscillator.stop(context.currentTime + duration);
    };

    const textFieldAction = async (a, b) => {
        if (a.key == 'Enter') {
            setActivateLoader(true)
            if (isOnline) {
                const payload = {
                    accountId: localStorage.getItem("accountId"),
                    patientCode: a.target.value,
                    orderdate: getDateWithFormat(metaDataConstants.yearMonthDateFormat)
                }
                const response = await post(ApiUrls().INMATE_DETAIL, payload)
                    .catch(function (error) {
                        // Handle errors here
                        console.error("Error:", error);
                    });
                const result = response?.data?.result?.[0]
                if (response?.status === 200 && result) {
                    const name = getPatientName(result.patientFirstName, result.patientLastName)
                    const imageUrl = `data:${result.documentType};base64,${result.imageString}`;
                    let isInmatePresent = await getSingleInmate(result.patientCode)
                    let hasAlreadyEaten = result.mealservetime.includes(JSON.parse(localStorage.getItem('mealType')).key)
                    if (!isInmatePresent && !hasAlreadyEaten) {
                        const updatedRows = [...rows]
                        let currentInmate = { id: result.id, code: result.patientCode, name: name, room: result.roomNumber, image: { avatar: imageUrl }, dietType: result.dietType }
                        saveInmateOffline(currentInmate)
                        updatedRows.unshift(currentInmate)
                        setRows(updatedRows);
                        playBeep(0.3)
                        setActivateLoader(false)
                    } else {
                        setShow(true)
                        setServerityStatus("error")
                        setMessage(metaDataConstants.inmateAlreadyScanned);
                        playBeep(1)
                        setActivateLoader(false)
                    }
                } else {
                    let isError = true;
                    setShow(true)
                    setServerityStatus("error")
                    setMessage(metaDataConstants.inmateDetailsnotFound);
                    playBeep(1, isError)
                    setActivateLoader(false)
                }
            } else {
                const allInmatesRecord = await getAllOfTable("AllInmateDetails");
                const mealPeriodId = JSON.parse(localStorage.getItem('mealType')).key
                const allInmatesSubmit = await getSingleRecordUsingKey("InmateSubmit", JSON.stringify(mealPeriodId));
                if (allInmatesRecord[0].allInmateDetails) {
                    const inmateDetail = allInmatesRecord[0].allInmateDetails.filter(inmate => inmate.patientCode == a.target.value)?.[0]
                    let hasAlreadyEaten = inmateDetail?.mealservetime.includes(mealPeriodId) || allInmatesSubmit?.inmateIds.includes(inmateDetail?.id)
                    if (inmateDetail) {
                        let isInmatePresent = await getSingleInmate(inmateDetail.patientCode)
                        if (!isInmatePresent && !hasAlreadyEaten) {
                            const name = getPatientName(inmateDetail.patientFirstName, inmateDetail.patientLastName)
                            const imageUrl =  `data:${inmateDetail?.documentType};base64,${inmateDetail?.imageString}`;
                            const updatedRows = [...rows]
                            let currentInmate = { id: inmateDetail.id, code: inmateDetail.patientCode, name: name, room: inmateDetail.roomNumber, image: { avatar: imageUrl }, dietType: inmateDetail.dietType }
                            saveInmateOffline(currentInmate)
                            updatedRows.unshift(currentInmate)
                            setRows(updatedRows);
                            playBeep(0.3)
                            setActivateLoader(false)
                        } else {
                            setShow(true)
                            setServerityStatus("error")
                            setMessage(metaDataConstants.inmateAlreadyScanned);
                            playBeep(1)
                            setActivateLoader(false)
                        }
                    } else {
                        let isError = true;
                        setShow(true)
                        setServerityStatus("error")
                        setMessage(metaDataConstants.inmateDetailsnotFound);
                        playBeep(1, isError)
                        setActivateLoader(false)
                    }
                }
            }
            document.querySelector('#inmatebarcode').value = '';
        }
    }

    const handleSelectionChange = (newSelection) => {
        setSelectionModel(newSelection);
    }

    const handleSubmit = async () => {
        const inmatesRecord = await getAllOfTable("Inmates");
        if (inmatesRecord) {
            let idString = ''
            inmatesRecord.forEach(el => {
                idString += ',' + el.id;
            })
            const mealPeriodId = JSON.parse(localStorage.getItem("mealType")).key
            if (isOnline) {
                const payload = {
                    patientIds: idString.substring(1),
                    serveTimeId: mealPeriodId,
                    orderDate: getDateWithFormat(metaDataConstants.yearMonthDateFormat),
                }
                const response = await post(ApiUrls().INMATE_SCANNING_ORDER, payload)
                    .catch(function (error) {
                        // Handle errors here
                        console.error("Error:", error);
                    });
                if (response?.status === 200) {
                    setShow(true)
                    setServerityStatus("success")
                    setMessage(metaDataConstants.submitSuccessfull);
                    removeCollection("Inmates")
                    setRows([])
                    setShowPostSubmitPopup(true)
                }
            } else {
                let isInmatePresent = await getSingleMealPeriodId(JSON.stringify(mealPeriodId))
                isInmatePresent ? submitInmateOffline(mealPeriodId, isInmatePresent.inmateIds + idString) : submitInmateOffline(mealPeriodId, idString.substring(1))
                setShow(true)
                setServerityStatus("success")
                setMessage(metaDataConstants.submitSuccessOffline);
                removeCollection("Inmates")
                setRows([])
                setShowPostSubmitPopup(true)
            }
        }
    }
    const handleDeleteInate = () =>{
        setShowDeleteConfirmPopup(true);
    }
    const handleDelete = () => {
        let updatedRows = [...rows]
        selectionModel.forEach(item => {
            const ind = updatedRows.findIndex(i => i.id == item)
            deleteDocFromCollection('Inmates', updatedRows[ind])
            updatedRows = updatedRows.filter(row => row.id != item)
        })
        setRows(updatedRows);
        setShowDeleteConfirmPopup(false);
        setShow(true)
        setServerityStatus("success")
        setMessage(metaDataConstants.deletedSuccessfully);
    }

    const routeToMenuServing = () => {
        navigate('/inmate_scan_form');
    }

    const signOut = () => {
        localStorage.clear();
        localStorage.removeItem("timer")
        deleteDb()
        navigate("/");
        window.location.reload();
    };

    const confirmDeleteInmatePopup = (
        <ModalPopup
                show={showDeleteConfirmPopup}
                onHide={() => setShowDeleteConfirmPopup(false)}
                size={"sm"}
                centered={true}
                modelHeader={<h5>{metaDataConstants.confirmDelete}</h5>}
                modelContent={<>
                    <h6>{metaDataConstants.confirmDeleteMessage}</h6>
                    <div className="footerButtons" style={{marginTop:"20px"}}>
                        
                        <Button
                            className="btn-black btn Ripple-parent btn btn-primary"
                            onClick={handleDelete}
                            style={{ marginRight:"10px", width: '127px' }}
                        >
                            {metaDataConstants.yes}
                        </Button>
                        <Button
                            className="btn-black btn Ripple-parent btn btn-primary"
                            onClick={()=>setShowDeleteConfirmPopup(false)}
                            style={{  width: '127px' }}
                        >
                            {metaDataConstants.no}
                        </Button>
                    </div>
                    </>
                }
                backdrop={"static"}
            />
    )

    return (
        <div className="inmateScanGridContainer">
            <Snackbar
                open={show}
                autoHideDuration={2000}
                onClose={() =>
                    handleClose({
                        vertical: "bottom",
                        horizontal: "right",
                    })
                }
            >
                <Alert severity={serverityStatus}>{message}</Alert>
            </Snackbar>
            <br />
            <Grid container style={{ margin: '10px 0 10px 15px' }}>
                <Grid xs={6} md={6}>
                    <h2 className="form-title">{metaDataConstants.inmateSummary}</h2>
                </Grid>
                <Grid xs={3} md={3}>
                </Grid>
                <Grid xs={3} md={3} style={{ textAlign: 'center' }}>
                    <Button variant="contained" className="submitButton btn btn-primary" color='success' onClick={routeToMenuServing}>{metaDataConstants.back}</Button>
                </Grid>
            </Grid>
            <br />
            <Grid container style={{ margin: '10px 0 10px 15px' }}>

                <Grid xs={3} md={3}>
                    <TextField id="inmatebarcode" label="Enter Barcode" variant="outlined" onKeyDown={textFieldAction} />
                </Grid>
                <Grid xs={3} md={3} style={{ textAlign: 'center' }}>
                    <div>{metaDataConstants.date} - {getDateWithFormat('MM/dd/yyyy')}</div>
                </Grid>

                <Grid xs={3} md={3} style={{ textAlign: 'center' }}>
                    <div>{metaDataConstants.mealPeriod} - {JSON.parse(localStorage.getItem("mealType"))?.label}</div>
                </Grid>
                <Grid xs={3} md={3} style={{ textAlign: 'center' }}>
                    <Button variant="contained" disabled={!selectionModel.length} className="deleteButton btn btn-primary" color='error' onClick={handleDeleteInate}>{metaDataConstants.delete}</Button>
                    <Button variant="contained" disabled={!rows.length} className="submitButton btn btn-primary" color='success' onClick={handleSubmit}>{metaDataConstants.submit}</Button>
                </Grid>
            </Grid>
            <DataGrid
                checkboxSelection
                style={rows.length > 0 ? {} : { height: '100px' }}
                columns={[
                    {
                        field: 'image', headerName: 'Picture', width: 60, editable: false, filterable: false, sortable: false,
                        renderCell: (params) => {
                            return (
                                <>
                                    <Avatar src={params.value.avatar} />
                                </>
                            );
                        }
                    },
                    { field: 'code', headerName: 'Barcode', width: 120, editable: false },
                    { field: 'name', headerName: 'Name', width: 180, editable: false },
                    { field: 'dietType', headerName: 'Diet', width: 180, editable: false },
                    { field: 'room', headerName: 'Room no', width: 150, editable: false },
                ]}
                rows={rows}
                isCellEditable={false}
                onRowSelectionModelChange={(newSelection) => handleSelectionChange(newSelection)}
                selectionModel={selectionModel}
                pagination
                ref={dataGridRef}
            />
            <ModalPopup
                show={showPostSubmitPopup}
                onHide={() => setShowPostSubmitPopup(false)}
                size={"sm"}
                centered={true}
                modelContent={

                    <div className="footerButtons">
                        <CheckCircleOutlineIcon style={{ color: 'green', fontSize: '4em', float: 'inline-start', marginRight: "20px" }} />
                        <h5>{metaDataConstants.thankYou}</h5>
                        <h5>{metaDataConstants.mealServedSuccess}</h5>
                        <br />
                        <Button
                            className="btn-black btn Ripple-parent btn btn-primary"
                            onClick={() => setShowPostSubmitPopup(false)}
                            style={{ margin: '3px', width: '127px' }}
                        >
                            {metaDataConstants.reScan}
                        </Button>
                        <Button
                            className="btn-black btn Ripple-parent btn btn-primary"
                            onClick={routeToMenuServing}
                            style={{ margin: '3px', width: '127px' }}
                        >
                            {metaDataConstants.inmateForm}
                        </Button>
                        {isOnline && <Button
                            className="btn-black btn Ripple-parent btn btn-primary"
                            onClick={signOut}
                            style={{ margin: '3px', width: '127px', marginLeft: '69px' }}
                        >
                            {metaDataConstants.logout}
                        </Button>}
                    </div>
                }
                backdrop={"static"}
            />
            {confirmDeleteInmatePopup}
            <Loader active={activateLoader} />
        </div>
    )
}

export default InmateScanGrid;